var _defs, _linearGradient, _use, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon-logo_svg__a",
    cx: 540.2,
    cy: 540,
    r: 537.8
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-logo_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 178.8,
    y1: 178.6,
    x2: 903.4,
    y2: 903.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47721"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-logo_svg__a",
    overflow: "visible",
    fill: "url(#icon-logo_svg__b)"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-logo_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-logo_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M887.7 181.6c-289.2-.9-416.2 237.7-468.4 429C354.9 366 202 176.8-76.3 176c-29.9-.1-61.1 2.5-95.1 6.5v9.5h16.3c332.7 1 473.8 457.7 473.1 685.8-.1 33.9 1.2 66.6 1 105.9-.5 157.5-33.1 171-160.8 189.6v8.2c57-2.6 169.8-6.3 233.6-6.1 67.9.2 184.6 3.3 241.7 7.5v-9.5c-164.3-15.5-170.9-56.2-170.5-183.8.1-33.9 1.6-69.2 1.7-103.2.8-272.9 123-694.8 444.8-693.8 12.2 0 24.4.1 38 1.5v-9.5a903.1 903.1 0 00-59.8-3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTA4MCAxMDgwIj48ZGVmcz48Y2lyY2xlIGlkPSJhIiBjeD0iNTQwLjIiIGN5PSI1NDAiIHI9IjUzNy44Ii8+PC9kZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIxNzguOCIgeTE9IjE3OC42IiB4Mj0iOTAzLjQiIHkyPSI5MDMuMiI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZjg5ODQxIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjQ3NzIxIi8+PC9saW5lYXJHcmFkaWVudD48dXNlIHhsaW5rOmhyZWY9IiNhIiBvdmVyZmxvdz0idmlzaWJsZSIgZmlsbD0idXJsKCNiKSIvPjxjbGlwUGF0aCBpZD0iYyI+PHVzZSB4bGluazpocmVmPSIjYSIgb3ZlcmZsb3c9InZpc2libGUiLz48L2NsaXBQYXRoPjxnIGNsaXAtcGF0aD0idXJsKCNjKSI+PHBhdGggZD0iTTg4Ny43IDE4MS42Yy0yODkuMi0uOS00MTYuMiAyMzcuNy00NjguNCA0MjlDMzU0LjkgMzY2IDIwMiAxNzYuOC03Ni4zIDE3NmMtMjkuOS0uMS02MS4xIDIuNS05NS4xIDYuNXY5LjVoMTYuM2MzMzIuNyAxIDQ3My44IDQ1Ny43IDQ3My4xIDY4NS44LS4xIDMzLjkgMS4yIDY2LjYgMSAxMDUuOS0uNSAxNTcuNS0zMy4xIDE3MS0xNjAuOCAxODkuNnY4LjJjNTctMi42IDE2OS44LTYuMyAyMzMuNi02LjEgNjcuOS4yIDE4NC42IDMuMyAyNDEuNyA3LjV2LTkuNWMtMTY0LjMtMTUuNS0xNzAuOS01Ni4yLTE3MC41LTE4My44LjEtMzMuOSAxLjYtNjkuMiAxLjctMTAzLjIuOC0yNzIuOSAxMjMtNjk0LjggNDQ0LjgtNjkzLjggMTIuMiAwIDI0LjQuMSAzOCAxLjV2LTkuNWE5MDMuMSA5MDMuMSAwIDAgMC01OS44LTN6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4K";
export { SvgIconLogo as ReactComponent };